import { WorldRepo } from "../phaser/world/WorldRepo"
import { StudentStoreSA } from "../react/students/StudentStoreSA"
import { fireBaseOptionsInUse } from "./FirebaseConfig"

declare const DEV_MODE: boolean

export enum FirebaseEnv {
    DEV,
    DEMO,
    PROD
}

export class CCUtils {

    static firebaseEnv = () => {
        if (fireBaseOptionsInUse.name === "e627c") {
            return FirebaseEnv.PROD
        } else if (fireBaseOptionsInUse.name === "demo") {
            return FirebaseEnv.DEMO
        } else if (fireBaseOptionsInUse.name === "dev") {
            return FirebaseEnv.DEV
        } else {
            throw new Error(`Bad firebase name ${fireBaseOptionsInUse.name}`)
        }
    }

    /* tslint:disable */
    /**
     * Shuffles array in place.
     *
     * Thanks SO:
     * https://stackoverflow.com/a/6274381/1313268
     *
     * @param {Array} array items The array containing the items.
     */
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static shuffle = (array: any[]): any[] => {
        for (let i = array.length; i; i--) {
            const j = Math.floor(Math.random() * i);
            [array[i - 1], array[j]] = [array[j], array[i - 1]]
        }
        return array
    }
    /* tslint:enable */

    static randomNumber = (belowExclusive: number): number => {
        return Math.floor(Math.random() * belowExclusive)
    }

    static randomIndex = <T>(indexFrom: Array<T>): number => {
        return Math.floor(Math.random() * indexFrom.length)
    }

    static returnRandom = <T>(...things: Array<T>): T => {
        return things[CCUtils.randomIndex(things)]
    }

    static asset = (assetPath: string): string => require("../../assets/" + assetPath)

    /**
     * Use this to do things like allowing audio to be skipped over for development purposes.
     */
    static debug = WorldRepo.isDebug() && DEV_MODE

    static envMode = DEV_MODE

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static enumValues<T extends EnumType>(enunn: any): Array<T> {
        return Object.keys(enunn).filter(key => isNaN(+key)).map(name => enunn[name]) as Array<T>
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static clearRepoKeys = (enunn: any) => {
        const keys: Array<string> = CCUtils.enumValues(enunn)
        for (const key of keys) {
            localStorage.removeItem(key)
        }
    }

    static genderifyFileName = (fileName: string) => {
        const nameSplit = fileName.split(".")
        if (nameSplit.length !== 2) {
            throw new Error(`file name ${fileName} must have one period.`)
        }
        return `${nameSplit[0]}-${StudentStoreSA.instance.isGirl() ? "girl" : "boy"}.${nameSplit[1]}`
    }

    static generateId = () => (
        "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c: string) => {
            // tslint:disable-next-line:no-bitwise
            const r = Math.random() * 16 | 0
            // tslint:disable-next-line:no-bitwise
            const v = c === "x" ? r : (r & 0x3 | 0x8)
            return v.toString(16)
        })
    )

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static prettyJson = (write: any): string => JSON.stringify(write, null, 2)

    static capsFirstChar = (toCap: string): string => toCap.charAt(0).toUpperCase() + toCap.slice(1).toLowerCase()

}

type EnumType = string | number

export const prettyJson = CCUtils.prettyJson

/**
 * Replaces Lodash "sortBy"
 *
 * Use like this (concat optional if you don't want to sort the source array):
 *
 * stuffInArray.concat().sort(sortBy((promise: PlaygroundPromise) => promise.date.toDate()))
 */
export const sortBy = <T, V>(valueAccessor: (toSort: T) => V) => {
    return (a, b) => (valueAccessor(a) > valueAccessor(b)) ? 1 : ((valueAccessor(b) > valueAccessor(a)) ? -1 : 0)
}

export type NumberMaybe = number | ""